<template>
  <div>
    <div v-if="isSecurity">
      <div v-if="br_detail != ''">
        <el-button type="primary" @click="downLoadPdf">百融PDF</el-button>

        <el-button type="warning" plain @click="createReport()"
          >重新生成该报告</el-button
        >

        <h1>{{ fkinfo.user_name }}</h1>
        <div class="info">
          <span>手机号：{{ fkinfo.user_phone }}</span>
          <span>身份证：{{ fkinfo.user_id_code }}</span>
          <span>用户id: {{ fkinfo.user_id }}</span>
        </div>
        <div class="info">
          <span
            >身份证号手机号归属地：{{ fkdata.KeyAttribution.cell.province }}
            {{ fkdata.KeyAttribution.cell.city }}
            {{ fkdata.KeyAttribution.cell.card_type }}</span
          >
        </div>

        <table border="1" style="border-collapse: collapse;" class="bt">
          <tr>
            <td>综合评分</td>
            <td>审核建议</td>
            <td>偿债压力指数</td>
            <td>法院被执行人-高级版</td>
            <td>借贷意向验证1</td>
            <td>借贷风险勘测1</td>
            <td>特殊名单验证</td>
            <td>法院被执行人-限高版</td>
          </tr>
          <tr>
            <th class="yanse2">{{ fkdata.RiskStrategy.Rule.weight }} 分</th>
            <th class="yanse3">{{ fkdata.RiskStrategy.Rule.decision }}</th>
            <th>
              {{
                fkdata.DebtRepayStress.nodebtscore
                  ? fkdata.DebtRepayStress.nodebtscore
                  : 0
              }}%
            </th>
            <th></th>
            <th class="yanse1"></th>
            <th class="yanse1">
              <block v-if="fkdata.Rule.hit_rules">
                <div v-for="data in fkdata.Rule.hit_rules.ruleapplyloan_cashon">
                  {{ data.name_rule }}
                </div>
              </block>
            </th>
            <th></th>
            <th></th>
          </tr>
        </table>

        <h3>申请意向-3C租赁</h3>
        <table border="1" style="border-collapse: collapse;">
          <tr v-if="fkdata.ApplyLoanC.d3">
            <th>
              按手机号查询,近3天在3C机构申请总次数:
              <span>{{
                fkdata.ApplyLoanC.d3.cell ? fkdata.ApplyLoanC.d3.cell.allnum : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近3天在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.d3.cell
                  ? fkdata.ApplyLoanC.d3.cell.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近3天在3C机构夜间申请机构数:<span>{{
                fkdata.ApplyLoanC.d3.cell
                  ? fkdata.ApplyLoanC.d3.cell.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近3天在3C机构申请总机构数:<span>{{
                fkdata.ApplyLoanC.d3.cell ? fkdata.ApplyLoanC.d3.cell.orgnum : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近3天在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.d3.cell
                  ? fkdata.ApplyLoanC.d3.cell.weekend_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近3天在3C机构周末申请机构数:<span>{{
                fkdata.ApplyLoanC.d3.cell
                  ? fkdata.ApplyLoanC.d3.cell.weekend_orgnum
                  : 0
              }}</span>
            </th>
          </tr>

          <tr v-if="fkdata.ApplyLoanC.d3">
            <th>
              按身份证号查询,近3天在3C机构申请总次数:
              <span>{{
                fkdata.ApplyLoanC.d3.id ? fkdata.ApplyLoanC.d3.id.allnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近3天在3C机构夜间申请次数:<span>{{
                fkdata.ApplyLoanC.d3.id
                  ? fkdata.ApplyLoanC.d3.id.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近3天在3C机构夜间申请机构数:<span>{{
                fkdata.ApplyLoanC.d3.id
                  ? fkdata.ApplyLoanC.d3.id.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近3天在3C机构申请总机构数:<span>{{
                fkdata.ApplyLoanC.d3.id ? fkdata.ApplyLoanC.d3.id.orgnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近3天在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.d3.id
                  ? fkdata.ApplyLoanC.d3.id.weekend_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近3天在3C机构周末申请机构数:<span>{{
                fkdata.ApplyLoanC.d3.id
                  ? fkdata.ApplyLoanC.d3.id.weekend_orgnum
                  : 0
              }}</span>
            </th>
          </tr>

          <tr v-if="fkdata.ApplyLoanC.d7">
            <th>
              按手机号查询,近7天在3C机构申请总次数:
              <span>{{
                fkdata.ApplyLoanC.d7.cell ? fkdata.ApplyLoanC.d7.cell.allnum : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近7天在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.d7.cell
                  ? fkdata.ApplyLoanC.d7.cell.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近7天在3C机构夜间申请机构数:<span>{{
                fkdata.ApplyLoanC.d7.cell
                  ? fkdata.ApplyLoanC.d7.cell.night_orgnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近7天在3C机构申请总机构数:<span>{{
                fkdata.ApplyLoanC.d7.cell ? fkdata.ApplyLoanC.d7.cell.orgnum : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近7天在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.d7.cell
                  ? fkdata.ApplyLoanC.d7.cell.weekend_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近7天在3C机构周末申请机构数:<span>{{
                fkdata.ApplyLoanC.d7.cell
                  ? fkdata.ApplyLoanC.d7.cell.weekend_orgnum
                  : 0
              }}</span>
            </th>
          </tr>

          <tr v-if="fkdata.ApplyLoanC.d7">
            <th>
              按身份证号查询,近7天在3C机构申请总次数:
              <span>{{
                fkdata.ApplyLoanC.d7.id ? fkdata.ApplyLoanC.d7.id.allnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近7天在3C机构夜间申请次数:<span>{{
                fkdata.ApplyLoanC.d7.id
                  ? fkdata.ApplyLoanC.d7.id.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近7天在3C机构夜间申请机构数:<span>{{
                fkdata.ApplyLoanC.d7.id
                  ? fkdata.ApplyLoanC.d7.id.night_orgnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近7天在3C机构申请总机构数:<span>{{
                fkdata.ApplyLoanC.d7.id ? fkdata.ApplyLoanC.d7.id.orgnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近7天在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.d7.id
                  ? fkdata.ApplyLoanC.d7.id.weekend_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近7天在3C机构周末申请机构数:<span>{{
                fkdata.ApplyLoanC.d7.id
                  ? fkdata.ApplyLoanC.d7.id.weekend_orgnum
                  : 0
              }}</span>
            </th>
          </tr>

          <tr v-if="fkdata.ApplyLoanC.d14">
            <th>
              按手机号查询,近14天在3C机构申请总次数:
              <span>{{
                fkdata.ApplyLoanC.d14.cell
                  ? fkdata.ApplyLoanC.d14.cell.allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近14天在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.d14.cell
                  ? fkdata.ApplyLoanC.d14.cell.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近14天在3C机构夜间申请机构数:<span>{{
                fkdata.ApplyLoanC.d14.cell
                  ? fkdata.ApplyLoanC.d14.cell.night_orgnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近14天在3C机构申请总机构数:<span>{{
                fkdata.ApplyLoanC.d14.cell
                  ? fkdata.ApplyLoanC.d14.cell.orgnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近14天在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.d14.cell
                  ? fkdata.ApplyLoanC.d14.cell.weekend_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近14天在3C机构周末申请机构数<span>{{
                fkdata.ApplyLoanC.d14.cell
                  ? fkdata.ApplyLoanC.d14.cell.weekend_orgnum
                  : 0
              }}</span>
            </th>
          </tr>

          <tr v-if="fkdata.ApplyLoanC.d14">
            <th>
              按身份证号查询,近14天在3C机构申请总次数:
              <span>{{
                fkdata.ApplyLoanC.d14.id ? fkdata.ApplyLoanC.d14.id.allnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近14天在3C机构夜间申请次数:<span>{{
                fkdata.ApplyLoanC.d14.id
                  ? fkdata.ApplyLoanC.d14.id.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近14天在3C机构夜间申请机构数:<span>{{
                fkdata.ApplyLoanC.d14.id
                  ? fkdata.ApplyLoanC.d14.id.night_orgnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近14天在3C机构申请总机构数:<span>{{
                fkdata.ApplyLoanC.d14.id ? fkdata.ApplyLoanC.d14.id.orgnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近14天在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.d14.id
                  ? fkdata.ApplyLoanC.d14.id.weekend_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近14天在3C机构周末申请机构数:<span>{{
                fkdata.ApplyLoanC.d14.id
                  ? fkdata.ApplyLoanC.d14.id.weekend_orgnum
                  : 0
              }}</span>
            </th>
          </tr>

          <tr v-if="fkdata.ApplyLoanC.m1">
            <th>
              按手机号查询,近一个月在3C机构申请总次数:
              <span>{{
                fkdata.ApplyLoanC.m1.cell ? fkdata.ApplyLoanC.m1.cell.allnum : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近一个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m1.cell
                  ? fkdata.ApplyLoanC.m1.cell.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近一个月在3C机构夜间申请机构数:<span>{{
                fkdata.ApplyLoanC.m1.cell
                  ? fkdata.ApplyLoanC.m1.cell.night_orgnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近一个月在3C机构申请总机构数:<span>{{
                fkdata.ApplyLoanC.m1.cell ? fkdata.ApplyLoanC.m1.cell.orgnum : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近一个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m1.cell
                  ? fkdata.ApplyLoanC.m1.cell.weekend_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近一个月在3C机构周末申请机构数<span>
                {{
                  fkdata.ApplyLoanC.m1.cell
                    ? fkdata.ApplyLoanC.m1.cell.weekend_orgnum
                    : 0
                }}</span
              >
            </th>
          </tr>

          <tr v-if="fkdata.ApplyLoanC.m1">
            <th>
              按身份证号查询,近一个月在3C机构申请总次数:
              <span>{{
                fkdata.ApplyLoanC.m1.id ? fkdata.ApplyLoanC.m1.id.allnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近一个月在3C机构夜间申请次数:<span>{{
                fkdata.ApplyLoanC.m1.id
                  ? fkdata.ApplyLoanC.m1.id.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近一个月在3C机构夜间申请机构数:<span>{{
                fkdata.ApplyLoanC.m1.id
                  ? fkdata.ApplyLoanC.m1.id.night_orgnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近一个月在3C机构申请总机构数:<span>{{
                fkdata.ApplyLoanC.m1.id ? fkdata.ApplyLoanC.m1.id.orgnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近一个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m1.id
                  ? fkdata.ApplyLoanC.m1.id.weekend_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近一个月在3C机构周末申请机构数:<span>{{
                fkdata.ApplyLoanC.m1.id
                  ? fkdata.ApplyLoanC.m1.id.weekend_orgnum
                  : 0
              }}</span>
            </th>
          </tr>
        </table>

        <table border="1" style="border-collapse: collapse;" class="table2">
          <tr v-if="fkdata.ApplyLoanC.m3">
            <th>
              按手机号查询,近三个月在3C机构申请总次数:
              <span>{{
                fkdata.ApplyLoanC.m3.cell ? fkdata.ApplyLoanC.m3.cell.allnum : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近三个月在3C机构平均每月申请次数(有申请月份平均):<span
                >{{
                  fkdata.ApplyLoanC.m3.cell
                    ? fkdata.ApplyLoanC.m3.cell.avg_monnum
                    : 0
                }}</span
              >
            </th>
            <th>
              按手机号查询,近三个月在3C机构最大月申请次数:<span>{{
                fkdata.ApplyLoanC.m3.cell
                  ? fkdata.ApplyLoanC.m3.cell.max_monnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近三个月在3C机构最小月申请次数:<span>{{
                fkdata.ApplyLoanC.m3.cell
                  ? fkdata.ApplyLoanC.m3.cell.min_monnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近三个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m3.cell
                  ? fkdata.ApplyLoanC.m3.cell.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近三个月在3C机构夜间申请机构数:<span>{{
                fkdata.ApplyLoanC.m3.cell
                  ? fkdata.ApplyLoanC.m3.cell.night_orgnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近三个月在3C机构申请总机构数:<span>{{
                fkdata.ApplyLoanC.m3.cell ? fkdata.ApplyLoanC.m3.cell.orgnum : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近三个月在3C机构有申请记录月份数:<span>{{
                fkdata.ApplyLoanC.m3.cell
                  ? fkdata.ApplyLoanC.m3.cell.tot_mons
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近三个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m3.cell
                  ? fkdata.ApplyLoanC.m3.cell.weekend_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近三个月在3C机构周末申请机构数:<span>{{
                fkdata.ApplyLoanC.m3.cell
                  ? fkdata.ApplyLoanC.m3.cell.weekend_orgnum
                  : 0
              }}</span>
            </th>
          </tr>

          <tr v-if="fkdata.ApplyLoanC.m3">
            <th>
              按身份证号查询,近三个月在3C机构申请总次数:
              <span>{{
                fkdata.ApplyLoanC.m3.id ? fkdata.ApplyLoanC.m3.id.allnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近三个月在3C机构平均每月申请次数(有申请月份平均):<span
                >{{
                  fkdata.ApplyLoanC.m3.id
                    ? fkdata.ApplyLoanC.m3.id.avg_monnum
                    : 0
                }}</span
              >
            </th>
            <th>
              按身份证号查询,近三个月在3C机构最大月申请次数:<span>{{
                fkdata.ApplyLoanC.m3.id ? fkdata.ApplyLoanC.m3.id.max_monnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近三个月在3C机构最小月申请次数:<span>{{
                fkdata.ApplyLoanC.m3.id ? fkdata.ApplyLoanC.m3.id.min_monnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近三个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m3.id
                  ? fkdata.ApplyLoanC.m3.id.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近三个月在3C机构夜间申请机构数:<span>{{
                fkdata.ApplyLoanC.m3.id
                  ? fkdata.ApplyLoanC.m3.id.night_orgnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近三个月在3C机构申请总机构数:<span>{{
                fkdata.ApplyLoanC.m3.id ? fkdata.ApplyLoanC.m3.id.orgnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近三个月在3C机构有申请记录月份数:<span>{{
                fkdata.ApplyLoanC.m3.id ? fkdata.ApplyLoanC.m3.id.tot_mons : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近三个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m3.id
                  ? fkdata.ApplyLoanC.m3.id.weekend_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近三个月在3C机构周末申请机构数:<span>{{
                fkdata.ApplyLoanC.m3.id
                  ? fkdata.ApplyLoanC.m3.id.weekend_orgnum
                  : 0
              }}</span>
            </th>
          </tr>

          <tr v-if="fkdata.ApplyLoanC.m6">
            <th>
              按手机号查询,近六个月在3C机构申请总次数:
              <span>{{
                fkdata.ApplyLoanC.m6.cell ? fkdata.ApplyLoanC.m6.cell.allnum : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近六个月在3C机构平均每月申请次数(有申请月份平均):<span
                >{{
                  fkdata.ApplyLoanC.m6.cell
                    ? fkdata.ApplyLoanC.m6.cell.avg_monnum
                    : 0
                }}</span
              >
            </th>
            <th>
              按手机号查询,近六个月在3C机构最大月申请次数:<span>{{
                fkdata.ApplyLoanC.m6.cell
                  ? fkdata.ApplyLoanC.m6.cell.max_monnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近六个月在3C机构最小月申请次数:<span>{{
                fkdata.ApplyLoanC.m6.cell
                  ? fkdata.ApplyLoanC.m6.cell.min_monnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近六个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m6.cell
                  ? fkdata.ApplyLoanC.m6.cell.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近六个月在3C机构夜间申请机构数:<span>{{
                fkdata.ApplyLoanC.m6.cell
                  ? fkdata.ApplyLoanC.m6.cell.night_orgnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近六个月在3C机构申请总机构数:<span>{{
                fkdata.ApplyLoanC.m6.cell ? fkdata.ApplyLoanC.m6.cell.orgnum : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近六个月在3C机构有申请记录月份数:<span>{{
                fkdata.ApplyLoanC.m6.cell
                  ? fkdata.ApplyLoanC.m6.cell.tot_mons
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近六个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m6.cell
                  ? fkdata.ApplyLoanC.m6.cell.weekend_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近六个月在3C机构周末申请机构数:<span>{{
                fkdata.ApplyLoanC.m6.cell
                  ? fkdata.ApplyLoanC.m6.cell.weekend_orgnum
                  : 0
              }}</span>
            </th>
          </tr>
          <tr v-if="fkdata.ApplyLoanC.m6">
            <th>
              按身份证号查询,近六个月在3C机构申请总次数:
              <span>{{
                fkdata.ApplyLoanC.m6.id ? fkdata.ApplyLoanC.m6.id.allnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近六个月在3C机构平均每月申请次数(有申请月份平均):<span
                >{{
                  fkdata.ApplyLoanC.m6.id
                    ? fkdata.ApplyLoanC.m6.id.avg_monnum
                    : 0
                }}</span
              >
            </th>
            <th>
              按身份证号查询,近六个月在3C机构最大月申请次数:<span>{{
                fkdata.ApplyLoanC.m6.id ? fkdata.ApplyLoanC.m6.id.max_monnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近六个月在3C机构最小月申请次数:<span>{{
                fkdata.ApplyLoanC.m6.id ? fkdata.ApplyLoanC.m6.id.min_monnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近六个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m6.id
                  ? fkdata.ApplyLoanC.m6.id.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近六个月在3C机构夜间申请机构数:<span>{{
                fkdata.ApplyLoanC.m6.id
                  ? fkdata.ApplyLoanC.m6.id.night_orgnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近六个月在3C机构申请总机构数:<span>{{
                fkdata.ApplyLoanC.m6.id ? fkdata.ApplyLoanC.m6.id.orgnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近六个月在3C机构有申请记录月份数:<span>{{
                fkdata.ApplyLoanC.m6.id ? fkdata.ApplyLoanC.m6.id.tot_mons : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近六个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m6.id
                  ? fkdata.ApplyLoanC.m6.id.weekend_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近六个月在3C机构周末申请机构数:<span>{{
                fkdata.ApplyLoanC.m6.id
                  ? fkdata.ApplyLoanC.m6.id.weekend_orgnum
                  : 0
              }}</span>
            </th>
          </tr>

          <tr v-if="fkdata.ApplyLoanC.m12">
            <th>
              按手机号查询,近十二个月在3C机构申请总次数:
              <span>{{
                fkdata.ApplyLoanC.m12.cell
                  ? fkdata.ApplyLoanC.m12.cell.allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近十二个月在3C机构平均每月申请次数(有申请月份平均):<span
                >{{
                  fkdata.ApplyLoanC.m12.cell
                    ? fkdata.ApplyLoanC.m12.cell.avg_monnum
                    : 0
                }}</span
              >
            </th>
            <th>
              按手机号查询,近十二个月在3C机构最大月申请次数:<span>{{
                fkdata.ApplyLoanC.m12.cell
                  ? fkdata.ApplyLoanC.m12.cell.max_monnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近十二个月在3C机构最小月申请次数:<span>{{
                fkdata.ApplyLoanC.m12.cell
                  ? fkdata.ApplyLoanC.m12.cell.min_monnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近十二个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m12.cell
                  ? fkdata.ApplyLoanC.m12.cell.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近十二个月在3C机构夜间申请机构数:<span>{{
                fkdata.ApplyLoanC.m12.cell
                  ? fkdata.ApplyLoanC.m12.cell.night_orgnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近十二个月在3C机构申请总机构数:<span>{{
                fkdata.ApplyLoanC.m12.cell
                  ? fkdata.ApplyLoanC.m12.cell.orgnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近十二个月在3C机构有申请记录月份数:<span>{{
                fkdata.ApplyLoanC.m12.cell
                  ? fkdata.ApplyLoanC.m12.cell.tot_mons
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近十二个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m12.cell
                  ? fkdata.ApplyLoanC.m12.cell.weekend_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按手机号查询,近十二个月在3C机构周末申请机构数:<span>{{
                fkdata.ApplyLoanC.m12.cell
                  ? fkdata.ApplyLoanC.m12.cell.weekend_orgnum
                  : 0
              }}</span>
            </th>
          </tr>
          <tr v-if="fkdata.ApplyLoanC.m12">
            <th>
              按身份证号查询,近十二个月在3C机构申请总次数:
              <span>{{
                fkdata.ApplyLoanC.m12.id ? fkdata.ApplyLoanC.m12.id.allnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近十二个月在3C机构平均每月申请次数(有申请月份平均):<span
                >{{
                  fkdata.ApplyLoanC.m12.id
                    ? fkdata.ApplyLoanC.m12.id.avg_monnum
                    : 0
                }}</span
              >
            </th>
            <th>
              按身份证号查询,近十二个月在3C机构最大月申请次数:<span>{{
                fkdata.ApplyLoanC.m12.id
                  ? fkdata.ApplyLoanC.m12.id.max_monnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近十二个月在3C机构最小月申请次数:<span>{{
                fkdata.ApplyLoanC.m12.id
                  ? fkdata.ApplyLoanC.m12.id.min_monnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近十二个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m12.id
                  ? fkdata.ApplyLoanC.m12.id.night_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近十二个月在3C机构夜间申请机构数:<span>{{
                fkdata.ApplyLoanC.m12.id
                  ? fkdata.ApplyLoanC.m12.id.night_orgnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近十二个月在3C机构申请总机构数:<span>{{
                fkdata.ApplyLoanC.m12.id ? fkdata.ApplyLoanC.m12.id.orgnum : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近十二个月在3C机构有申请记录月份数:<span>{{
                fkdata.ApplyLoanC.m12.id ? fkdata.ApplyLoanC.m12.id.tot_mons : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近十二个月在3C机构周末申请次数:<span>{{
                fkdata.ApplyLoanC.m12.id
                  ? fkdata.ApplyLoanC.m12.id.weekend_allnum
                  : 0
              }}</span>
            </th>
            <th>
              按身份证号查询,近十二个月在3C机构周末申请机构数:<span>{{
                fkdata.ApplyLoanC.m12.id
                  ? fkdata.ApplyLoanC.m12.id.weekend_orgnum
                  : 0
              }}</span>
            </th>
          </tr>
        </table>

        <h3>团伙欺诈排查（通用版）</h3>
        <table border="1" style="border-collapse: collapse;" class="table2">
          <tr>
            <th>
              查询人欺诈团伙群组规模:
              <span>{{
                fkdata.FraudRelation_g.group_num
                  ? fkdata.FraudRelation_g.group_num
                  : 0
              }}</span>
            </th>
            <th>
              查询人欺诈团伙等级:
              <span>{{
                fkdata.FraudRelation_g.list_level
                  ? fkdata.FraudRelation_g.list_level
                  : 0
              }}</span>
            </th>
          </tr>
        </table>
      </div>
      <div v-else class="bgelse">
        <div class="tishi">提示：请生成报告后再查看该报告！</div>
        <div class="baogao">百融风控报告没有生成</div>
        <div class="shhengcheng">
          <el-button type="warning" plain @click="createReport()">生成该报告</el-button>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="warning_info">提示：请充值！</div>
    </div>
  </div>
</template>

<script>
import FKApi from "@/api/fengkong.js";
import isSecurity from "@/utils/isSecurity.js";
export default {
  props: ["fkid", "order_id"],
  data() {
    return {
      isSecurity: true, // 查看消费金额是否超过充值金额
      fkdata: "",
      fkinfo: "",
      fkdata2: "",
      br_detail: ""
    };
  },
  beforeCreate() {
    const self = this;
    isSecurity().then(result => {
      console.log(result);
      self.isSecurity = result;
    });
  },
  async created() {
    const id = this.$route.query.id;
    if (id) {
      const res = await FKApi.riskDetail({id}, true);
      this.setDetail(res);
    } else this.queryUserDetail();
  },
  methods: {
    downLoadPdf: async function () {
      let swift_number = this.fkdata.swift_number + "," + this.fkdata2;
      const { msg } = await FKApi.pdf({ swift_number }, true)
      window.open(msg, "_blank");
    },
    createReport: async function() {
      let queryData = { user_id: this.fkid, order_id: this.order_id };
      queryData.risk_type = 2, 
      await FKApi.riskAdd(queryData, true);
      queryData.risk_type = 1;
      await FKApi.riskAdd(data1, true)
      this.$message.success("生成百融报告");
      this.queryUserDetail();        
    },
    queryUserDetail: async function () {
      let Params = { user_id: this.fkid, order_id: this.order_id };
      const res = await FKApi.detailsUser(Params, true)
      this.setDetail(res);
    },
    setDetail: function (res) {
      const { data: { data } } = res;
      console.log(data)
      const self = this;
      self.loading = false;
      this.br_detail = data;
      this.fkdata = JSON.parse(data[0].risk_text);
      this.fkinfo = data[0];
      data.length > 1 && (this.fkdata2 = data[1].swift_number);
    }      
  }
};
</script>

<style>
.yanse1 {
  color: #158e1c;
}

.yanse2 {
  color: #55668d;
  font-size: 20px;
}

.yanse3 {
  color: #158e1c;
  font-size: 20px;
}

h1 {
  text-align: center;
}

.decision {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  padding: 5px;
  color: #158e1c;
}

.decision span {
  margin: 0 10px;
}

.info {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
}

.info span {
  margin-left: 10px;
}

table > tr > th {
  padding: 10px;
}

.bt {
  width: 100%;
  margin-bottom: 20px;
}

.bt > tr > td {
  text-align: center;
  height: 50px;
}

.bt > tr > th {
  text-align: center;
}

table {
  margin-top: 10px;
}

.table2 {
  margin-top: 10px;
}

.bgelse {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.bgelse .tishi {
  margin-top: 50px;
}

.bgelse .baogao {
  /* margin-left: 700px; */
  font-size: 30px;
}

.bgelse .shhengcheng {
  /* margin-left: 760px; */
  font-size: 30px;
  margin-top: 50px;
}

.bg_else {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/fengkong/operation/detail.vue